/** کلید trail در location.state */
export const BREADCRUMB_TRAIL_KEY = 'breadcrumbTrail';

const STORAGE_PREFIX = 'crm:breadcrumb:';

/** کلید ذخیره trail — فقط pathname تا tab/query مسیر را نشکند */
export const buildBreadcrumbPathKey = (pathname, search = '') => {
  if (pathname) return pathname;
  return '/';
};

/** مسیر کامل برای navigate (با query) */
export const buildBreadcrumbNavigatePath = (pathname, search = '') =>
  `${pathname || '/'}${search || ''}`;

export const persistBreadcrumbTrail = (pathKey, trail) => {
  if (!pathKey || !Array.isArray(trail) || !trail.length) return;
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${pathKey}`, JSON.stringify(trail));
  } catch {
    /* ignore quota errors */
  }
};

export const loadBreadcrumbTrail = (pathKey) => {
  if (!pathKey) return null;
  const keys = [pathKey, String(pathKey).split('?')[0]].filter(
    (k, i, arr) => k && arr.indexOf(k) === i,
  );
  for (const key of keys) {
    try {
      const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
      if (!raw) continue;
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch {
      /* try next key */
    }
  }
  return null;
};

/** @typedef {{ path: string, label: string }} BreadcrumbCrumb */

/** trail پیش‌فرض: لیست > موجودیت */
export const createEntityBreadcrumbTrail = (listPath, listLabel, entityPath, entityLabel) => [
  { path: listPath, label: listLabel },
  { path: entityPath, label: entityLabel || '—' },
];

/** افزودن یا برش trail هنگام navigate */
export const appendBreadcrumbTrail = (trail, entityPath, entityLabel) => {
  const base = Array.isArray(trail) ? trail : [];
  const normalizedTarget = String(entityPath || '').split('?')[0];
  const idx = base.findIndex(
    (c) => String(c.path || '').split('?')[0] === normalizedTarget,
  );
  if (idx >= 0) {
    const next = base.slice(0, idx + 1);
    next[idx] = { ...next[idx], path: entityPath, label: entityLabel || next[idx].label };
    return next;
  }
  return [...base, { path: entityPath, label: entityLabel || '—' }];
};

export const resolveInitialBreadcrumbTrail = ({
  pathKey,
  locationState,
  listPath,
  listLabel,
  entityPath,
  entityLabel,
}) => {
  const fromState = locationState?.[BREADCRUMB_TRAIL_KEY];
  if (Array.isArray(fromState) && fromState.length) {
    persistBreadcrumbTrail(pathKey, fromState);
    return fromState;
  }

  const stored = loadBreadcrumbTrail(pathKey);
  if (stored?.length) return stored;

  return createEntityBreadcrumbTrail(listPath, listLabel, entityPath, entityLabel);
};

export const mergeBreadcrumbIntoNavigationState = (extraState = {}, trail) => ({
  ...extraState,
  [BREADCRUMB_TRAIL_KEY]: trail,
});

/** حذف آخرین پله (مثلاً هنگام بازگشت از ویرایش به مشاهده) */
export const trailWithoutLastCrumb = (trail) =>
  Array.isArray(trail) && trail.length > 1 ? trail.slice(0, -1) : Array.isArray(trail) ? [...trail] : [];

export const buildListToDetailNavigationState = ({
  listSnapshot,
  returnTo,
  listPath,
  listLabel,
  entityPath,
  entityLabel,
  extraState = {},
}) => {
  const trail = createEntityBreadcrumbTrail(listPath, listLabel, entityPath, entityLabel);
  persistBreadcrumbTrail(buildBreadcrumbPathKey(entityPath.split('?')[0]), trail);
  persistBreadcrumbTrail(entityPath, trail);
  return {
    ...(listSnapshot
      ? {
          restoreListState: listSnapshot,
          listState: listSnapshot,
        }
      : {}),
    returnTo,
    ...mergeBreadcrumbIntoNavigationState(extraState, trail),
  };
};
